import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { PermissionServiceService } from '../servies/permission-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
  // styles: [
  //   `
  //     :host ::ng-deep .menu-icon,
  //     :host ::ng-deep .pi {
  //       font-size: 1.2rem;
  //       width: 1.5rem;
  //       height: 1.5rem;
  //       display: inline-flex;
  //       align-items: center;
  //       justify-content: center;

  //     }

  //     :host ::ng-deep .p-panelmenu .p-menuitem-icon,
  //     :host ::ng-deep .p-menu .p-menuitem-icon {
  //       font-size: 1.2rem;
  //       width: 1.5rem;
  //       height: 1.5rem;
  //       display: inline-flex;
  //       align-items: center;
  //       justify-content: center;
  //     }
  //   `,
  // ],
  styles: [
    `
      :host ::ng-deep .pi {
        font-size: 16px;
        width: 20px;
        height: 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        vertical-align: middle;
      }
    
      :host ::ng-deep .pi-box {
        font-size: 17px;
      }
      
      :host ::ng-deep .pi-envelope {
        font-size: 15px;
      }
      
      :host ::ng-deep .pi-cog {
        font-size: 18px;
      }
      
      :host ::ng-deep .pi-power-off {
        font-size: 15px;
      }
      
      :host ::ng-deep .p-menuitem-icon {
        margin-right: 0.5rem;
      }
    `,
  ],
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];

  constructor(
    private permissionService: PermissionServiceService,
    private router: Router
  ) { }

  ngOnInit() {
    this.model = [
      {
        items: [
          {
            label: 'Materials & SOR',
            icon: 'pi pi-box',
            items: [
              { label: 'Materials', routerLink: ['/materials'], menuId: 4 },
              { label: 'SOR', routerLink: ['/sor'], menuId: 5 },
            ],
          },
        ],
      },
      {
        items: [
          {
            label: 'Jobs',
            icon: 'pi pi-envelope',
            routerLink: ['/jobs'],
            menuId: 10,
          },
          {
            label: 'DoC',
            icon: 'pi pi-box',
            items: [
              { label: 'Work Order Received', routerLink: ['/work-order-received'], menuId: 11 },
              { label: 'Work Orders Central', routerLink: ['/work-orders-central'], menuId: 12 },
            ],
          },
          {
            label: 'Setup',
            icon: 'pi pi-cog',
            items: [
              { label: 'Status', routerLink: ['/status'], menuId: 14 },
              { label: 'Business', routerLink: ['/business'], menuId: 1 },
              { label: 'Sites', routerLink: ['/sites'], menuId: 2 },
              { label: 'Users', routerLink: ['/users'], menuId: 3 },
              { label: 'Checklist', routerLink: ['/create-checklist'], menuId: 6 },
              { label: 'Material Visibility', routerLink: ['/material-visibility'], menuId: 7 },
              { label: 'Price List', routerLink: ['/price-list-margins'], menuId: 8 },
              { label: 'User Access Role', routerLink: ['/user-access-role'], menuId: 9 },
            ],
          },
          {
            label: 'Contractor',
            icon: 'pi pi-envelope',
            routerLink: ['/myjob'],
            menuId: 13,
          },
           {
            label: 'Doc Report',
            icon: 'pi pi-envelope',
            routerLink: ['/doc-report'],
            menuId: 13,
          },
          {
            label: 'Log Out',
            icon: 'pi pi-power-off',
            routerLink: ['/account/login'],
            command: () => this.logout(),
            menuId: 14,
          },
        ],
      },
    ];

    // Filter menu items based on permissions
    this.filterMenuItems();
  }

  // filterMenuItems(): void {
  //   this.model.forEach((group) => {
  //     group.items = group.items
  //       .map((item) => {
  //         if (item.items) {
  //           item.items = item.items.filter((subItem: any) =>
  //             this.permissionService.hasAnyPermission(subItem.menuId)
  //           );
  //         }
  //         return item.items?.length > 0 || this.permissionService.hasAnyPermission(item.menuId)
  //           ? item
  //           : null;
  //       })
  //       .filter((item: any) => item !== null);
  //   });

  //   // Remove empty groups
  //   this.model = this.model.filter((group) => group.items.length > 0);
  // }
  filterMenuItems(): void {
    this.model.forEach((group) => {
      group.items = group.items
        .map((item) => {
          if (item.items) {
            item.items = item.items.filter((subItem: any) => {
              const hasPermission = this.permissionService.hasAnyPermission(subItem.menuId);
              console.log(`SubItem: ${subItem.label}, MenuId: ${subItem.menuId}, HasPermission: ${hasPermission}`);
              return hasPermission;
            });
          }
          const hasPermission =
            item.menuId === 14 || // Allow "Log Out" menu item without permission check
            this.permissionService.hasAnyPermission(item.menuId);
          console.log(`Item: ${item.label}, MenuId: ${item.menuId}, HasPermission: ${hasPermission}`);
          return item.items?.length > 0 || hasPermission ? item : null;
        })
        .filter((item: any) => item !== null);
    });

    // Remove empty groups
    this.model = this.model.filter((group) => group.items.length > 0);
  }

  logout(): void {
    this.router.navigate(['/account/login']);
    // Clear local storage
    localStorage.clear();
  }
}
